'use strict';

var CharacteristicTypes = require('consts').HeatCharacteristicTypes;
var Misc = require('utils/misc');
var i18n = require('utils/i18n');
var Consts = require('consts');

const useOutdoorSensor = 1026;
const fourPointCharacteristic = 1035;

const fourPointValues = [
    'maxBackFlowTemp',
    'minBackFlowTemp',
    'maxFlowTemp',
    'minFlowTemp',
    'outdoorTemperature0',
    'outdoorTemperature1',
    'outdoorTemperature2',
    'outdoorTemperature3',
    'backFlowTemperature0',
    'backFlowTemperature1',
    'backFlowTemperature2',
    'backFlowTemperature3',
    'flowTemperatureDay0',
    'flowTemperatureDay1',
    'flowTemperatureDay2',
    'flowTemperatureDay3',
    'flowTemperatureNight0',
    'flowTemperatureNight1',
    'flowTemperatureNight2',
    'flowTemperatureNight3',
];

const gradientValues = [
    'maxBackFlowTemp',
    'minBackFlowTemp',
    'maxFlowTemp',
    'minFlowTemp',
    'daySetpoint',
    'nightSetpoint',
    'gradientRegulation',
    'gradientHeatCircuit',
    'levelRegulation',
    'levelHeatCircuit',
];

var Parameter = Backbone.Model.extend({
    defaults: {
        flowType: 'flowTemperatureDay',
        circuitNr: 10,
    },

    getValueDefaults: function () {
        return {
            // aktuelle Vorlauftemperatur
            currentSetPoint: {
                name: i18n.TR('Aktuelle Vorlauftemperatur'),
                nr: 1000,
                unit: '°C',
                val: 0,
                min: 0,
                max: 1300,
                step: 1,
            },

            // 'X-Achse'
            currentTemperature: {
                name: i18n.TR('Außentemperatur'),
                nr: 10,
                unit: '°C',
                val: 0,
                min: -400,
                max: 500,
                step: 1,
            }, // aktuelle Temperatur
            outdoorTemperature0: {
                name: i18n.TR('Außentemperatur'),
                nr: 1013,
                unit: '°C',
                val: 0,
                min: -400,
                max: 500,
                step: 1,
            }, // 1. Punkt
            outdoorTemperature1: {
                name: i18n.TR('Außentemperatur'),
                nr: 1014,
                unit: '°C',
                val: 0,
                min: -400,
                max: 500,
                step: 1,
            }, // 2. Punkt
            outdoorTemperature2: {
                name: i18n.TR('Außentemperatur'),
                nr: 1015,
                unit: '°C',
                val: 0,
                min: -400,
                max: 500,
                step: 1,
            }, // 3. Punkt
            outdoorTemperature3: {
                name: i18n.TR('Außentemperatur'),
                nr: 1016,
                unit: '°C',
                val: 0,
                min: -400,
                max: 500,
                step: 1,
            }, // 4. Punkt

            // Parameter
            useOutdoorSensor: { name: i18n.TR('Außenfühler AF1'), nr: 1026, unit: '', val: 0, min: 0, max: 1, step: 1 },
            fourPointChar: { name: i18n.TR('4-Punkte-Kennlinie'), nr: 1035, unit: '', val: 0, min: 0, max: 1, step: 1 },
            coldRegulation: { name: i18n.TR('Kälteregelung'), nr: 1028, unit: '', val: 0, min: 0, max: 1, step: 1 },
            underfloorHeating: {
                name: i18n.TR('Fußbodenheizung'),
                nr: 1029,
                unit: '',
                val: 0,
                min: 0,
                max: 1,
                step: 1,
            },
            maxBackFlowTemp: {
                name: i18n.TR('max. Rücklauftemp.'),
                nr: 1011,
                unit: '°C',
                val: 0,
                min: 50,
                max: 900,
                step: 1,
            },
            minBackFlowTemp: {
                name: i18n.TR('min. Rücklauftemp.'),
                nr: 1012,
                unit: '°C',
                val: 0,
                min: 50,
                max: 900,
                step: 1,
            },
            maxFlowTemp: {
                name: i18n.TR('max. Vorlauftemp.'),
                nr: 1001,
                unit: '°C',
                val: 0,
                min: 50,
                max: 1300,
                step: 1,
            },
            minFlowTemp: {
                name: i18n.TR('min. Vorlauftemp.'),
                nr: 1002,
                unit: '°C',
                val: 0,
                min: 50,
                max: 1300,
                step: 1,
            },

            // 4-Punkte-Kennlinie
            // Regelkreis
            backFlowTemperature0: {
                name: i18n.TR('Rücklauf'),
                nr: 1025,
                unit: '°C',
                val: 0,
                min: 50,
                max: 900,
                step: 1,
            }, // 1. Punkt
            backFlowTemperature1: {
                name: i18n.TR('Rücklauf'),
                nr: 1026,
                unit: '°C',
                val: 0,
                min: 50,
                max: 900,
                step: 1,
            }, // 2. Punkt
            backFlowTemperature2: {
                name: i18n.TR('Rücklauf'),
                nr: 1027,
                unit: '°C',
                val: 0,
                min: 50,
                max: 900,
                step: 1,
            }, // 3. Punkt
            backFlowTemperature3: {
                name: i18n.TR('Rücklauf'),
                nr: 1028,
                unit: '°C',
                val: 0,
                min: 50,
                max: 900,
                step: 1,
            }, // 4. Punkt

            // Heizkreis
            flowTemperatureDay0: {
                name: i18n.TR('Vorlauf Tag'),
                nr: 1017,
                unit: '°C',
                val: 0,
                min: 50,
                max: 1300,
                step: 1,
            }, // 1. Punkt
            flowTemperatureDay1: {
                name: i18n.TR('Vorlauf Tag'),
                nr: 1018,
                unit: '°C',
                val: 0,
                min: 50,
                max: 1300,
                step: 1,
            }, // 2. Punkt
            flowTemperatureDay2: {
                name: i18n.TR('Vorlauf Tag'),
                nr: 1019,
                unit: '°C',
                val: 0,
                min: 50,
                max: 1300,
                step: 1,
            }, // 3. Punkt
            flowTemperatureDay3: {
                name: i18n.TR('Vorlauf Tag'),
                nr: 1020,
                unit: '°C',
                val: 0,
                min: 50,
                max: 1300,
                step: 1,
            }, // 4. Punkt

            flowTemperatureNight0: {
                name: i18n.TR('Vorlauf Nacht'),
                nr: 1021,
                unit: '°C',
                val: 0,
                min: 50,
                max: 1300,
                step: 1,
            }, // 1. Punkt
            flowTemperatureNight1: {
                name: i18n.TR('Vorlauf Nacht'),
                nr: 1022,
                unit: '°C',
                val: 0,
                min: 50,
                max: 1300,
                step: 1,
            }, // 2. Punkt
            flowTemperatureNight2: {
                name: i18n.TR('Vorlauf Nacht'),
                nr: 1023,
                unit: '°C',
                val: 0,
                min: 50,
                max: 1300,
                step: 1,
            }, // 3. Punkt
            flowTemperatureNight3: {
                name: i18n.TR('Vorlauf Nacht'),
                nr: 1024,
                unit: '°C',
                val: 0,
                min: 50,
                max: 1300,
                step: 1,
            }, // 4. Punkt

            // Steigungskennlinie
            daySetpoint: { name: i18n.TR('Sollwert Tag'), nr: 1003, unit: '°C', val: 0, min: 0, max: 400, step: 1 },
            nightSetpoint: { name: i18n.TR('Sollwert Nacht'), nr: 1004, unit: '°C', val: 0, min: 0, max: 400, step: 1 },

            gradientRegulation: { name: i18n.TR('Steigung'), nr: 1009, unit: '', val: 0, min: 2, max: 32, step: 0.1 },
            gradientHeatCircuit: { name: i18n.TR('Steigung'), nr: 1006, unit: '', val: 0, min: 2, max: 32, step: 0.1 },

            levelRegulation: { name: i18n.TR('Niveau'), nr: 1010, unit: '', val: 0, min: -300, max: 300, step: 1 },
            levelHeatCircuit: { name: i18n.TR('Niveau'), nr: 1007, unit: '', val: 0, min: -300, max: 300, step: 1 },

            // Festwertregelung
            fixedValueDay: {
                name: i18n.TR('Festwerttemperatur Tag'),
                nr: 1042,
                unit: '°C',
                val: 0,
                min: 50,
                max: 1300,
                step: 1,
            },
            fixedValueNight: {
                name: i18n.TR('Festwerttemperatur Nacht'),
                nr: 1043,
                unit: '°C',
                val: 0,
                min: 50,
                max: 1300,
                step: 1,
            },

            // ---------------> TRINKWASSER <------------
            // Trinkwasser Register
            dwTemperatureDay: {
                name: i18n.TR('Trinkwassertemperatur Tag'),
                nr: 1800,
                unit: '°C',
                val: 0,
                min: 200,
                max: 900,
                step: 1,
            },
            dwMaxTemperature: {
                name: i18n.TR('Maximale Trinkwassertemperatur'),
                nr: 1801,
                unit: '°C',
                val: 0,
                min: 200,
                max: 900,
                step: 1,
            },
            dwMinTemperature: {
                name: i18n.TR('Minimale Trinkwassertemperatur'),
                nr: 1802,
                unit: '°C',
                val: 0,
                min: 200,
                max: 900,
                step: 1,
            },
            hystersis: { name: i18n.TR('Schaltdifferenz'), nr: 1803, unit: '°C', val: 0, min: 10, max: 300, step: 1 },
            chargingTempBoost: {
                name: i18n.TR('Ladetemperatur Überhöhung'),
                nr: 1804,
                unit: '°C',
                val: 0,
                min: 0,
                max: 300,
                step: 1,
            },
            chargingTempMax: {
                name: i18n.TR('Maximale Ladetemperatur'),
                nr: 1806,
                unit: '°C',
                val: 0,
                min: 50,
                max: 950,
                step: 1,
            },
            dwTemperatureNight: {
                name: i18n.TR('Trinkwassertemperatur Nacht'),
                nr: 1807,
                unit: '°C',
                val: 0,
                min: 200,
                max: 900,
                step: 1,
            },

            // thermische Desinfektion (Trinkwasser)
            desinfectionTemp: {
                name: i18n.TR('Desinfektionstemperatur'),
                nr: 1830,
                unit: '°C',
                val: 0,
                min: 400,
                max: 900,
                step: 1,
            },
            desinfectionDay: { name: i18n.TR('Wochentag'), nr: 1831, unit: '', val: 0, min: 0, max: 7, step: 1 },
            desinfectionStart: {
                name: i18n.TR('Startzeit'),
                nr: 1832,
                unit: 'min',
                val: 0,
                min: 0,
                max: 2345,
                step: 15,
            },
            desinfectionStop: {
                name: i18n.TR('Stoppzeit'),
                nr: 1833,
                unit: 'min',
                val: 0,
                min: 0,
                max: 2345,
                step: 15,
            },
            derivativActionTime: {
                name: i18n.TR('Haltezeit'),
                nr: 1839,
                unit: 'min',
                val: 0,
                min: 0,
                max: 255,
                step: 1,
            },

            parallelPumpCancel: { name: i18n.TR('Abbruch'), nr: 1834, unit: 'min', val: 0, min: 2, max: 120, step: 1 },
            parallelPumpLimitTemp: {
                name: i18n.TR('Grenztemperatur'),
                nr: 1835,
                unit: '°C',
                val: 0,
                min: 200,
                max: 900,
                step: 1,
            },
            timeTillPriority: {
                name: i18n.TR('Zeit bis Trinkwasservorrang'),
                nr: 1836,
                unit: 'min',
                val: 0,
                min: 2,
                max: 10,
                step: 1,
            },
            limitingFactorInvers: {
                name: i18n.TR('Begrenzungsfaktor'),
                nr: 1837,
                unit: '',
                val: 0,
                min: 1,
                max: 1000,
                step: 1,
            },

            // Trinkwasser Coils
            maxChargingTempActive: {
                name: i18n.TR('Maximale Ladetemperaturbegrenzung aktiv'),
                nr: 1803,
                unit: '',
                val: 0,
                min: 0,
                max: 1,
                step: 1,
            },
            parallelPumpOp: {
                name: i18n.TR('Pumpenparallellauf'),
                nr: 1830,
                unit: '',
                val: 0,
                min: 0,
                max: 1,
                step: 1,
            },
            intermediateHeating: {
                name: i18n.TR('Zwischenheizen'),
                nr: 1831,
                unit: '',
                val: 0,
                min: 0,
                max: 1,
                step: 1,
            },
            priorityByInverseOp: {
                name: i18n.TR('Vorrang Inversbetrieb'),
                nr: 1832,
                unit: '',
                val: 0,
                min: 0,
                max: 1,
                step: 1,
            },
            priorityBySetBackOp: {
                name: i18n.TR('Vorrang Absenkbetrieb'),
                nr: 1833,
                unit: '',
                val: 0,
                min: 0,
                max: 1,
                step: 1,
            },
            ZPduringCharging: {
                name: i18n.TR('ZP läuft während der Speicherladung'),
                nr: 1835,
                unit: '',
                val: 0,
                min: 0,
                max: 1,
                step: 1,
            },
            thermalDesinfection: {
                name: i18n.TR('Thermische Desinfektion'),
                nr: 1838,
                unit: '',
                val: 0,
                min: 0,
                max: 1,
                step: 1,
            },
        };
    },

    coilIDs: ['useOutdoorSensor', 'fourPointChar', 'underfloorHeating', 'coldRegulation'],
    drinkingWaterCoilIDs: [
        'maxChargingTempActive',
        'parallelPumpOp',
        'intermediateHeating',
        'priorityByInverseOp',
        'priorityBySetBackOp',
        'ZPduringCharging',
        'thermalDesinfection',
    ],
    drinkingWaterRegisterIDs: [
        'dwTemperatureDay',
        'dwMaxTemperature',
        'dwMinTemperature',
        'hystersis',
        'chargingTempBoost',
        'chargingTempMax',
        'dwTemperatureNight',
        'desinfectionTemp',
        'desinfectionDay',
        'desinfectionStart',
        'desinfectionStop',
        'derivativActionTime',
        'parallelPumpCancel',
        'parallelPumpLimitTemp',
        'timeTillPriority',
        'limitingFactorInvers',
    ],

    initialize: function (options) {
        this.firmware = options.firmware;
        this.circuitNr = options.circuitNr;
        this.values = this.getValueDefaults();

        // check data points for completeness (data points for warm water circuits are checked separately)
        this.valuesComplete = this.get('register')[10] != undefined && this.get('coils')[useOutdoorSensor] != undefined;
        _.each(
            _.omit(this.values, ['useOutdoorSensor'], this.drinkingWaterRegisterIDs, this.drinkingWaterCoilIDs),
            function (value, key) {
                this.valuesComplete = this.valuesComplete && this.hasValue(key);
            },
            this
        );

        // init register values
        _.each(
            _.omit(this.values, ['useOutdoorSensor']),
            function (value, key) {
                this.setValue(key, Misc.getSignedInt(this.getCircuitDataPoint(key)));
            },
            this
        );

        // check data intigrity for warm water circuit.
        if (this.circuitNr === 90) {
            var warmWaterRegister = [
                1800, 1801, 1802, 1803, 1804, 1806, 1807, 1830, 1831, 1832, 1833, 1834, 1835, 1836, 1837, 1838, 1839,
            ];
            var warmWaterCoils = [1830, 1803, 1831, 1832, 1833, 1835, 1838];
            this.valuesComplete = true;
            _.each(
                warmWaterRegister,
                function (r) {
                    this.valuesComplete = this.valuesComplete && this.get('register')[r] !== undefined;
                },
                this
            );

            _.each(
                warmWaterCoils,
                function (c) {
                    this.valuesComplete = this.valuesComplete && this.get('coils')[c] !== undefined;
                },
                this
            );
        }

        // init outdoor sensor
        this.values['useOutdoorSensor'].val = this.get('coils')[useOutdoorSensor];

        // floor-heating? -> reduce maximum heat to 50 °C
        if (this.get('coils')[1029] === 1) {
            for (var i = 0; i < 4; i++) {
                this.values['backFlowTemperature' + i].max = 500;
                this.values['flowTemperatureDay' + i].max = 500;
                this.values['flowTemperatureNight' + i].max = 500;
            }
            this.values.maxBackFlowTemp.max = 500;
            this.values.minBackFlowTemp.max = 500;
            this.values.maxFlowTemp.max = 500;
            this.values.minFlowTemp.max = 500;
        }
    },

    // sets the given value, if it is valid. The value is valid if:
    // 1. it is a number
    // 2. it is inside the boundaries of the value
    // 3. The maximum is larger than the minimum
    setLimit: function (value, isMin) {
        value = parseInt(value);
        // invalid value? -> return existing value and do nothing
        if (isNaN(value)) {
            return this.values[id].val;
        }
        var type = this.get('flowType') === 'backFlowTemperature' ? 'BackFlowTemp' : 'FlowTemp';
        var min = 50;
        var max = this.values['max' + type].max;
        // ensure max>=min
        if (isMin) {
            max = Math.min(max, this.getValue('max' + type).val);
            var id = 'min' + type;
        } else {
            min = Math.max(min, this.getValue('min' + type).val);
            var id = 'max' + type;
        }

        // restrict to range and save
        this.values[id].val = Misc.clamp(value, min, max);
    },

    setOutdoorTemperature: function (position, value) {
        if (isNaN(value)) {
            return;
        }
        // value must be larger than (left neighbor +1 °C) and larger than max
        var min = position === 0 ? -400 : this.values['outdoorTemperature' + (position - 1)].val + 10;
        // value must be smaller than (right neighbor -1 °C) and smaller than min
        var max = position === 3 ? 500 : this.values['outdoorTemperature' + (position + 1)].val - 10;

        // restrict to range and save
        this.values['outdoorTemperature' + position].val = Misc.clamp(value, min, max);
    },

    // setChargingTemperatur sets the chargin temperatur boost.
    // The chargin temperatur has no own register but is instead a combination of two values:
    // chargin temperatur = set point (for the drinking water temperatur) + charging temperature boost
    setChargingTemperatur: function (chargingTemperatur, day) {
        var value = parseInt(chargingTemperatur);
        // invalid value? -> abort
        if (isNaN(value)) {
            return;
        }
        // limit the chargintemp,  constraints:
        // - dwTemperatureDay + chargingTempBoost <= chargingTempMax
        // - dwTemperaturNight + chargingTempBoost <= chargingTempMax
        // - chargingTempBoost > hystersis
        // - chargingTempBoost <= chargingBoost maximum value

        // ensure that neither dwTemperatureDay nor dwTemperatureNight surpass chargingTempMax
        if (this.getValue('maxChargingTempActive').val === 1) {
            value = Math.min(value, this.getValue('chargingTempMax').max);
        }

        // get chargingTemBoost
        var dayTemp = this.getValue('dwTemperatureDay').val;
        var nightTemp = this.getValue('dwTemperatureNight').val;
        value -= day ? dayTemp : nightTemp;

        // hystersis must be smaller than chargingTempBoost
        value = Math.max(value, this.getValue('hystersis').val + 10);
        this.setValue('chargingTempBoost', value);
    },

    setTurnOffLimit: function (limit, day) {
        var value = parseInt(limit);
        // invalid value? -> abort
        if (isNaN(value)) {
            return;
        }
        var setPoint = day ? this.getValue('dwTemperatureDay').val : this.getValue('dwTemperatureNight').val;
        value -= setPoint;

        value = Math.min(value, this.getValue('chargingTempBoost').val - 10);
        this.setValue('hystersis', value);
    },

    setTurnOnLimit: function (id, limit) {
        var value = parseInt(limit);
        // invalid value? -> abort
        if (isNaN(value)) {
            return;
        }

        // limit value by dwMaxTemperature and dwMinTemperature
        value = Misc.clamp(value, this.values['dwMinTemperature'].val, this.values['dwMaxTemperature'].val);

        // ensure that chargingTempBoost + value <= maxChargingTemp
        var currentChargingTempLimit = this.getValue('chargingTempBoost').max + this.getValue('dwTemperatureDay').max;
        if (this.getValue('maxChargingTempActive').val === 1) {
            currentChargingTempLimit = this.getValue('chargingTempMax').val - value;
        }
        if (this.getValue('chargingTempBoost').val > currentChargingTempLimit) {
            // cannot reduce the chargingTempBoost/hystersis below minimum -> invalid change
            if (
                currentChargingTempLimit < this.getValue('chargingTempBoost').min ||
                currentChargingTempLimit - 10 < this.getValue('hystersis').min
            ) {
                return;
            }
            // limit is not respected? -> reduce chargingTempBoost
            var diff = this.getValue('chargingTempBoost').val - currentChargingTempLimit;
            this.setValue('chargingTempBoost', currentChargingTempLimit);
            // The difference between hystersis and chargingTempBoost should stay the same
            this.setValue('hystersis', this.getValue('hystersis').val - diff);
        }
        this.setValue(id, value);
    },

    setValue: function (id, value) {
        value = parseInt(value);
        // invalid value? -> abort
        if (isNaN(value)) {
            return;
        }

        // restrict value to range and save
        this.values[id].val = Misc.clamp(value, this.values[id].min, this.values[id].max);
        return;
    },

    hasValue: function (id) {
        return this.getCircuitDataPoint(id) !== undefined;
    },

    setDrinkingTemperatureLimit: function (id, value) {
        value = parseInt(value);
        // invalid value? -> abort
        if (isNaN(value)) {
            return;
        }
        if (id === 'dwMaxTemperature') {
            value = Math.max(value, this.getValue('dwMinTemperature').val);
        } else {
            value = Math.min(value, this.getValue('dwMaxTemperature').val);
        }
        this.setValue(id, value);
    },

    getValue: function (id) {
        return $.extend({}, this.values[id], { val: this.values[id].val });
    },

    _getPoints: function (idPrefix, fct) {
        var values = [];
        for (var i = 0; i < 4; i++) {
            values.push(fct(this.values[idPrefix + i]));
        }
        return values;
    },

    getPoints: function (idPrefix) {
        return this._getPoints(idPrefix, function (value) {
            return $.extend({}, value);
        });
    },

    getPointValues: function (idPrefix) {
        return this._getPoints(idPrefix, function (value) {
            return value.val;
        });
    },

    // INFO FOR setType AND getType
    // - constant: There is one value for day and one for night and that's it
    // - gradient: The temperatur is regulated according to the outdoor temperatur based on a monoton function
    //             the colder it gets, the higher the heating temperatur is set.
    // - 4-point:  Similar to the previous, but instead of a predefined function, four outdoor temperatures
    //             are chosen and for each a corresponding heating temperatur. Between those points, we interpolate
    //             linearly.

    // Each circuit has its own Coil to decides if an outdoor sensor should be used or not. If it is not used,
    // than the constant regulation is activated. Else either the gradient or the 4-point regulation can be chosen.
    // For a controller with firmware prior to 2.50 there is an exception for the circuits 2 and 3:
    // They borow circuit 1's coil to decide if an outdoor sensor should be used. So they do not have an own coil for that.
    // This implies, that you cannot have a gradient- or 4-point regulation on circuit 2 and a constant regulation for
    // circuit 1 with these firmwares.
    setType: function (type) {
        var useOS = type === CharacteristicTypes.ConstantValue ? 0 : 1;
        if (this.standardBehaviour()) {
            this.setCoil(useOutdoorSensor, useOS);
        } else {
            this.attributes.coils[useOutdoorSensor] = useOS;
        }
        this.setCoil(fourPointCharacteristic, type === CharacteristicTypes.FourPoint ? 1 : 0);
    },

    getType: function () {
        var isConstant = false;
        if (this.standardBehaviour()) {
            isConstant = 0 === this.getCoil(useOutdoorSensor);
        } else {
            isConstant = 0 === this.attributes.coils[useOutdoorSensor];
        }

        if (isConstant) {
            return CharacteristicTypes.ConstantValue;
        }
        if (this.getCoil(fourPointCharacteristic) === 1) {
            return CharacteristicTypes.FourPoint;
        }
        return CharacteristicTypes.Gradient;
    },

    // return the maximum allowed value for the current flow type
    max: function (flowType) {
        flowType = flowType || this.get('flowType');
        if (flowType === 'backFlowTemperature') {
            return this.values.maxBackFlowTemp.val;
        }
        return this.values.maxFlowTemp.val;
    },

    // return the minimum allowed value for the current flow type
    min: function (flowType) {
        flowType = flowType || this.get('flowType');
        if (flowType === 'backFlowTemperature') {
            return this.values.minBackFlowTemp.val;
        }
        return this.values.minFlowTemp.val;
    },

    // return all registers and coils
    getAllWriteableValues: function (circuitNr) {
        var result = { register: [], coils: [] };
        var offsetRegister = Consts.CircuitOffsetsRegister[circuitNr];
        var offsetCoils = Consts.CircuitOffsetsCoils[circuitNr];

        // circuit uses outdoor sensor?
        if (this.standardBehaviour()) {
            result.coils.push({
                address: useOutdoorSensor + offsetCoils,
                value: this.getCoil(useOutdoorSensor) === 1,
            });
        } else {
            result.coils.push({
                address: useOutdoorSensor,
                value: this.attributes.coils[useOutdoorSensor] === 1,
            });
        }

        if (this.getType() != CharacteristicTypes.ConstantValue) {
            result.coils.push({
                address: fourPointCharacteristic + offsetCoils,
                value: this.attributes.coils[fourPointCharacteristic + offsetCoils] === 1,
            });

            var valuesToWrite = this.getType() === CharacteristicTypes.FourPoint ? fourPointValues : gradientValues;

            // omit coils and current temperature. current temperature is not writeable and coils are handled separatly.
            _.each(
                _.pick(this.values, valuesToWrite),
                function (object, key) {
                    result.register.push({
                        address: object.nr + offsetRegister,
                        value: Misc.getUnsignedInt(object.val),
                    });
                },
                this
            );
        } else {
            result.register.push(
                {
                    address: this.values['fixedValueDay'].nr + offsetRegister,
                    value: Misc.getUnsignedInt(this.values['fixedValueDay'].val),
                },
                {
                    address: this.values['fixedValueNight'].nr + offsetRegister,
                    value: Misc.getUnsignedInt(this.values['fixedValueNight'].val),
                }
            );
        }
        return result;
    },

    // fetches the correct data point from the coil- or register list depending on the present circuit
    getCircuitDataPoint: function (id) {
        // outdoortemperatur is circuit independent -> always return the same
        if (id == 'currentTemperature') {
            return this.get('register')[10];
        }

        if (_.contains(this.coilIDs, id)) {
            return this.getCoil(this.values[id].nr);
        }
        if (_.contains(this.drinkingWaterCoilIDs, id)) {
            return this.get('coils')[this.values[id].nr];
        }
        if (_.contains(this.drinkingWaterRegisterIDs, id)) {
            return this.get('register')[this.values[id].nr];
        }

        return this.getRegister(this.values[id].nr);
    },

    // setCoil sets the given coil of the current circuit to the given value
    setCoil: function (coil, value) {
        this.attributes.coils[coil + Consts.CircuitOffsetsCoils[this.circuitNr]] = value;
    },

    // getCoil returns the value of the given coil of the current circuit
    getCoil: function (coil) {
        return this.get('coils')[coil + Consts.CircuitOffsetsCoils[this.circuitNr]];
    },

    // getCoil returns the value of the given register of the current circuit
    getRegister: function (register) {
        return this.get('register')[register + Consts.CircuitOffsetsRegister[this.circuitNr]];
    },

    standardBehaviour: function () {
        return (
            Misc.isFirmwareSufficient(this.firmware, '2.50') || // recent firmware
            this.circuitNr <= 11 || // not circuit 2 or 3
            this.circuitNr >= 110
        );
    },

    // converts 1234 (=12:34) to 7234 minutes (=12*60+34)
    minutesToClockNumber: function (cn) {
        cn = parseInt(cn);
        return Math.floor(cn / 60) * 100 + cn - Math.floor(cn / 60) * 60;
    },

    // converts 94 minutes to 134 (=1:34)
    clockNumberToMinutes: function (minutes) {
        minutes = parseInt(minutes);
        return (minutes % 100) + ((minutes - (minutes % 100)) / 100) * 60;
    },
});

module.exports = Parameter;
